import type { DataSchema } from 'types';
import { TABLE_CELL_TYPE } from 'types/enums';

export const heliosFunctionsDataScheme = {
  id: {
    label: 'showId',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.id',
    hidden: true,
  },
  number: {
    label: 'number',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.number',
  },
  name: {
    label: 'name',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.name',
  },
  heliosFunctionId: {
    label: 'heliosFunctionId',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.heliosFunctionId',
  },
  type: {
    label: 'type',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.type',
  },
  datasourceName: {
    label: 'datasourceName',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.datasourceName',
  },
  isEntryFunction: {
    label: 'isRecordFunction',
    type: TABLE_CELL_TYPE.SWITCH,
    translationKey: 'table.header.isRecordFunction',
  },
  column: {
    label: 'column',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.column',
  },
  parentColumn: {
    label: 'parentColumn',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.parentColumn',
  },
  isCommon: {
    label: 'isCommon',
    type: TABLE_CELL_TYPE.SWITCH,
    translationKey: 'table.header.isCommon',
  },
} satisfies DataSchema;
